var cov_199mcbsxbv = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Scroll/fixedLength.tsx",
      hash = "2810c0aec014a14d53b858a1e0341121e9f854e5",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Scroll/fixedLength.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 39
        },
        end: {
          line: 7,
          column: 49
        }
      },
      "1": {
        start: {
          line: 8,
          column: 22
        },
        end: {
          line: 8,
          column: 54
        }
      },
      "2": {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 40
        }
      },
      "3": {
        start: {
          line: 9,
          column: 26
        },
        end: {
          line: 9,
          column: 40
        }
      },
      "4": {
        start: {
          line: 11,
          column: 6
        },
        end: {
          line: 11,
          column: 74
        }
      },
      "5": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 55
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 15
          },
          end: {
            line: 4,
            column: 16
          }
        },
        loc: {
          start: {
            line: 4,
            column: 54
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 4
          },
          end: {
            line: 6,
            column: 5
          }
        },
        loc: {
          start: {
            line: 6,
            column: 13
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 6
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 9,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 9,
            column: 40
          }
        }, {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 9,
            column: 40
          }
        }],
        line: 9
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Scroll/fixedLength.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
export default function (Bar) {
  cov_199mcbsxbv.f[0]++;

  var FixedLength =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(FixedLength, _PureComponent);

    var _super = _createSuper2(FixedLength);

    function FixedLength() {
      _classCallCheck(this, FixedLength);

      return _super.apply(this, arguments);
    }

    _createClass(FixedLength, [{
      key: "render",
      value: function render() {
        cov_199mcbsxbv.f[1]++;

        var _ref = (cov_199mcbsxbv.s[0]++, this.props),
            length = _ref.length,
            scrollLength = _ref.scrollLength;

        var barLength = (cov_199mcbsxbv.s[1]++, length / scrollLength * length);
        cov_199mcbsxbv.s[2]++;

        if (barLength < 20) {
          cov_199mcbsxbv.b[0][0]++;
          cov_199mcbsxbv.s[3]++;
          barLength = 20;
        } else {
          cov_199mcbsxbv.b[0][1]++;
        }

        cov_199mcbsxbv.s[4]++;
        return (
          /*#__PURE__*/
          React.createElement(Bar, Object.assign({}, this.props, {
            length: length,
            barLength: barLength,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 11,
              columnNumber: 14
            }
          }))
        );
      }
    }]);

    return FixedLength;
  }(PureComponent);

  cov_199mcbsxbv.s[5]++;
  return FixedLength;
}